import * as types from '../constants/keyword';

const initialState = {
    id: '',
    keywords: [],
    found: 0,
    showing: 0,
    authorized: false,
    loading: false,
    error: false
};

const keyword = (state = initialState, {
    type,
    ...action
}) => {
    switch (type) {
        case types.GET_KEYWORDS:
            return {
                ...state,
                loading: true,
                error: false
            };

        case types.SET_KEYWORDS:
            return {
                ...state,
                id: action.id,
                keywords: action.keywords,
                found: action.found,
                showing: action.showing,
                authorized: action.authorized,
                loading: false,
                error: false
            };

        case types.ERROR_KEYWORDS:
            return {
                ...state,
                id: '',
                keywords: [],
                found: 0,
                showing: 0,
                loading: false,
                error: true,
                authorized: false
            };

        default: return state;
    }
};

export default keyword;